/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Versand Timer
class WFShippingTimer extends HTMLElement {
  constructor() {
    super();
    this.timerText = document.getElementById("wf-timer-text");
    this.countdown = document.getElementById("wf-countdown");
  }

  connectedCallback() {
    this.targetHour = parseInt(this.getAttribute("data-target-hour"));
    this.targetMinute = parseInt(this.getAttribute("data-target-minute"));
    this.shippingDays = this.getAttribute("data-shipping-days").split(',').map(Number); // e.g., "1,2,3,4,5" for Monday to Friday
    console.log(this.targetHour, this.targetMinute, this.shippingDays);

    this.updateTimer();
    this.style.opacity = 1;
  }

  updateTimer() {
    const now = new Date();
    let targetTime = new Date();
    targetTime.setHours(this.targetHour, this.targetMinute, 0, 0);

    // Check if today is a shipping day
    if (!this.shippingDays.includes(now.getDay())) {
      // Find the next shipping day
      let daysUntilNextShipping = 1;
      while (!this.shippingDays.includes((now.getDay() + daysUntilNextShipping) % 7)) {
        daysUntilNextShipping++;
      }
      targetTime.setDate(now.getDate() + daysUntilNextShipping);
    } else if (now >= targetTime) {
      // If today is a shipping day but the target time has passed, set for the next shipping day
      targetTime.setDate(targetTime.getDate() + 1);
      while (!this.shippingDays.includes(targetTime.getDay())) {
        targetTime.setDate(targetTime.getDate() + 1);
      }
    }

    const remainingTime = targetTime - now;

    // Calculate hours, minutes, and seconds
    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    this.countdown.innerText = `${hours}hr ${minutes}min ${seconds}sec`;

    // Update the timer text based on the next shipping day
    const daysUntilNextShipping = Math.ceil(remainingTime / (1000 * 60 * 60 * 24));
    if (daysUntilNextShipping === 0) {
      this.timerText.innerText = "Versand heute!";
    } else if (daysUntilNextShipping === 1) {
      this.timerText.innerText = "Versand morgen!";
    } else {
      const nextShippingDay = targetTime.toLocaleDateString('de-DE', { weekday: 'long' });
      this.timerText.innerText = `Versand am ${nextShippingDay.charAt(0).toUpperCase() + nextShippingDay.slice(1)}!`;
    }

    setTimeout(() => this.updateTimer(), 1000);
  }
}

customElements.define("wf-shipping-timer", WFShippingTimer);

class WFAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcements = this.querySelectorAll(".wf-announcement-item");
    this.nextButton = this.querySelector(".wf-announcement-next");
    this.prevButton = this.querySelector(".wf-announcement-prev");
    this.currentIndex = 0;
    this.delay = this.getAttribute("data-delay");
    this.autoRotate = this.getAttribute("data-auto-rotate");
    console.log(this.delay, this.autoRotate);
    this.interval = null;
  }

  connectedCallback() {
    this.updateAnnouncementDisplay();
    this.setupEventListeners();
    if (this.autoRotate === "true") {
      this.startAutoRotate();
    }
  }

  updateAnnouncementDisplay() {
    this.announcements.forEach((item, idx) => {
      item.classList.remove("active");
      if (idx === this.currentIndex) {
        item.classList.add("active");
      }
    });
  }

  nextAnnouncement() {
    this.announcements[this.currentIndex].style.transform = "translateY(100%)";
    this.currentIndex = (this.currentIndex + 1) % this.announcements.length;
    this.announcements[this.currentIndex].style.transform = "translateY(0)";
    this.updateAnnouncementDisplay();
  }

  prevAnnouncement() {
    this.announcements[this.currentIndex].style.transform = "translateY(-100%)";
    this.currentIndex =
      (this.currentIndex - 1 + this.announcements.length) %
      this.announcements.length;
    this.announcements[this.currentIndex].style.transform = "translateY(0)";
    this.updateAnnouncementDisplay();
  }

  resetInterval() {
    if (this.autoRotate === "true") {
      clearInterval(this.interval);
      this.startAutoRotate();
    }
  }

  startAutoRotate() {
    this.interval = setInterval(() => this.nextAnnouncement(), this.delay);
  }

  stopAutoRotate() {
    clearInterval(this.interval);
  }

  setupEventListeners() {
    this.nextButton.addEventListener("click", () => {
      this.nextAnnouncement();
      this.resetInterval();
    });

    this.prevButton.addEventListener("click", () => {
      this.prevAnnouncement();
      this.resetInterval();
    });
  }

  disconnectedCallback() {
    this.stopAutoRotate();
    this.nextButton.removeEventListener("click", this.nextAnnouncement);
    this.prevButton.removeEventListener("click", this.prevAnnouncement);
  }
}

customElements.define("wf-announcement-bar", WFAnnouncementBar);

// AGB Checkout Cart
document.addEventListener("DOMContentLoaded", function () {
  checkTermsforCheckout();

  document.addEventListener("cart:rerendered", (e) => {
    checkTermsforCheckout();
  });
});

function checkTermsforCheckout() {
  const termsCheckbox = document.getElementById("terms-checkbox");
  const checkoutButton = document.querySelector(".cart-recap__checkout");
  if(!termsCheckbox || !checkoutButton){
    console.log('Checkout Button or Checkbox is missing');
    return;
  }
  termsCheckbox.addEventListener("change", function () {
    checkoutButton.disabled = !termsCheckbox.checked;
  });

  checkoutButton.disabled = !termsCheckbox.checked;
}
